import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  savedCalculations: [], // Array to store calculations
};

const CalculatorSlice = createSlice({
  name: "calculatorSlice",
  initialState,
  reducers: {
    saveCalculation(state, action) {
      state.savedCalculations.push(action.payload);
    },
    clearCalculations(state) {
      state.savedCalculations = [];
    },
  },
});

export const { saveCalculation, clearCalculations } = CalculatorSlice.actions;
export default CalculatorSlice.reducer;
